export default __webpack_public_path__ + "static/media/checked.16c84092.png";